import * as Raven from "raven-js";
import * as WebFontLoader from 'webfontloader';
WebFontLoader.load({
  google: {
    families: ['Roboto:300,400,500,700', 'Material Icons'],
  },
});
// See SDK documentation for language specific usage.
Raven.config("https://6bf30719be1b44c7afa1a653a3ab52bd@sentry.io/239181", {
  release: "0e4fdef81448dcfa0e16ecc4433ff3997aa53572"
});

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Index, { IndexModel } from "./view/Index/Index";
import { Api } from "./utility/IApi";
import { HttpClient } from "./utility/HttpClient";
import Login, { LoginModel } from "./view/Login/Login";
import { IConfig } from "./IConfig";
import { DataStore } from "./repository/DataStore";
import "./index.css";
import * as queryString from "qs";
import Register, { RegisterModel } from "./view/Register/Register";
import ResetPasswordView, { ResetPasswordModel } from "./view/ResetPassword/ResetPassword";
import ExecuteResetPasswordView, { ExecuteResetPasswordModel } from "./view/ExecuteResetPassword/ExecuteResetPassword";
import VerifyAccount, { VerfiyAccountModel } from "./view/VerifyAccount/VerifyAccount";
import { InputValidator } from "./utility/IInputValidator";
import { DatabaseKey } from "./repository/IDataStore";

import { Observable, Observer } from "rxjs";
import { isNullOrUndefined } from "util";
import { IUser } from "./model/ModelTypes";
import { ServicesProvider, IServicesProvider } from "./di/IServicesProvider";
import { IAuthenticationService, AuthenticationService } from "./utility/IAuthenticationService";
import { CircularProgress } from "react-md";
import PageNotFound from "./view/PageNotFound/PageNotFound";
import * as moment from 'moment';
function prepareApp() {

  const config: IConfig = require("Config");
  const dataStore = new DataStore();
  let servicesProvider: IServicesProvider;
  let authService: IAuthenticationService;
  if (
    window.location.pathname !== "/login" &&
    window.location.pathname.indexOf("/users/passwords/reset") === -1 &&
    window.location.pathname !== "/register" &&
    window.location.pathname !== "/passwords/forget" &&
    !window.location.pathname.includes("/users/verify") 
  ) { 
  dataStore.getDocuments<Observable<IUser>>(DatabaseKey.user)
  .flatMap( item => item)
  .first()
  .flatMap( item => {
    if (isNullOrUndefined(item)) {
      throw new Error("Invalid User");
    } else {
      return ServicesProvider.GetServicesProviderWithUser(config, dataStore, item);
    }
  })
  .flatMap( services => {
    servicesProvider = services;
    let user = services.getUser();
    if (!isNullOrUndefined(user.lastAuthenticated)) {
      if ( 
        (moment().toDate().getTime() - (1000 * 60 * 60 * 2)) > moment(user.lastAuthenticated).toDate().getTime()  
      ) { 
        authService = servicesProvider.getAuthenticationService();
        return services.getAuthenticationService().authenticateUser();          
      } else {
        return Observable.create( (observer: Observer<{}>) => {
          observer.next({});
          observer.complete();
        });
      }
    } else {
      throw new Error("Invalud User");
    }
  })
  .subscribe(
    result => {
      getLoggedInRoutes(servicesProvider);
    },
    error => {
      dataStore.clear().subscribe( () => {
        const newDataStore = new DataStore();
        authService = new AuthenticationService(new Api(new HttpClient(config), undefined), newDataStore);
        ReactDOM.render(
          getLoggedOutRoutes()
        , document.getElementById(
        "root"
      ) as HTMLElement);
      });
      
    }
  );
  ReactDOM.render(
    <div className="root">
        <CircularProgress centered={true} id="Progress" />
    </div>
    , 
    document.getElementById(
      "root"
    ) as HTMLElement
  );
  } else {
    authService = new AuthenticationService(new Api(new HttpClient(config), undefined), dataStore);
    ReactDOM.render(
      getLoggedOutRoutes()
    , document.getElementById(
    "root"
  ) as HTMLElement);
  }
  function prepareLoginElement(): JSX.Element {
    const api = new Api(new HttpClient(config) , undefined);
    const service = authService;
    const loginModel = new LoginModel(api, service, getLoggedInRoutes);
    return <Login model={loginModel} />;
  }

  function prepareRegisterElement(): JSX.Element {
    const api = new Api(new HttpClient(config), undefined);
    return <Register model={new RegisterModel(api, new InputValidator())} />;
  }
  function prepareResetPasswordElement(): JSX.Element {
    const api = new Api(new HttpClient(config), undefined);
    return <ResetPasswordView model={new ResetPasswordModel(api, new InputValidator())} />;
  }

  function prepareExecuteResetPasswordElement(code: string): JSX.Element {
    const api = new Api(new HttpClient(config), undefined);
    return <ExecuteResetPasswordView model={new ExecuteResetPasswordModel(api, new InputValidator(), code)} />;
  }

  function getLoggedInRoutes(provider: IServicesProvider) {
    ReactDOM.render(
      <Router>
            <Switch>
            <Route 
                path="/users/passwords/reset" 
                render={(props) =>
                  prepareExecuteResetPasswordElement(queryString.parse(props.location.search.replace("?", "")).code)} 
            />            
            <Route
                path="/register"
                render={() => prepareRegisterElement()}
            />
            <Route
                path="/passwords/forget"
                render={() => prepareResetPasswordElement()}
            />
            <Route
                path="/organisastions/:orgCode/users/verify"
                render={(props) => {
                  const api = new Api(new HttpClient(config), undefined);
                  return <VerifyAccount
                    model={new VerfiyAccountModel(api)}
                    orgCode={props.match.params.orgCode}
                    code={queryString.parse(props.location.search.replace("?", "")).code}
                  />;
                }}
            />
            <Route 
              path="/" 
              render={(props) => <Index model={new IndexModel(provider)} other={props}/>} 
            />            
            <Route component={PageNotFound}/>
            </Switch>
        </Router>
      , 
      document.getElementById(
      "root"
    ) as HTMLElement);
  }

  function getLoggedOutRoutes() {
    return (
      <Router>
            <div className="root">
            <Switch>
            <Route 
                path="/users/passwords/reset" 
                render={(props) =>
                  prepareExecuteResetPasswordElement(queryString.parse(props.location.search.replace("?", "")).code)} 
            />
            <Route 
                path="/login" 
                render={() => 
                  prepareLoginElement()
                } 
            />
            <Route
                path="/register"
                render={() => prepareRegisterElement()}
            />
            <Route
                path="/passwords/forget"
                render={() => prepareResetPasswordElement()}
            />
            <Route
                path="/organisastions/:orgCode/users/verify"
                render={(props) => {
                  const api = new Api(new HttpClient(config), undefined);
                  return <VerifyAccount
                    model={new VerfiyAccountModel(api)}
                    orgCode={props.match.params.orgCode}
                    code={queryString.parse(props.location.search.replace("?", "")).code}
                  />;
                }}
            />
            <Redirect to="/login" />
            <Route component={PageNotFound}/>
            </Switch>
            </div>
          </Router>
    );
  }
}
prepareApp();


// WEBPACK FOOTER //
// ./src/index.tsx